import React, { memo } from 'react'
import Card from 'transfix-ui/components/Card'
import Typography from 'transfix-ui/core/Typography'
import { ICarrierApplicationStates, Maybe } from 'types/graphqlTypes'
import ExtendedCarrierScorecard from 'apps/carrier/components/GeneralInformation/CarrierSummary/components/ExtendedCarrierScorecard'
import { ERateRank } from 'apps/carrier/components/GeneralInformation/CarrierSummary/components/ExtendedCarrierScorecard/types'

export interface ICarrierSummaryCardProps {
  className?: string
  carrierName: string
  status: ICarrierApplicationStates
  rate: ERateRank
  carrierScore: Maybe<number>
  shipmentsCount?: Maybe<number>
  bounceRate: Maybe<number>
  onTimeRate: Maybe<number>
  trackingRate: Maybe<number>
  mcNumber: Maybe<string>
  dotNumber: Maybe<string>
  hqValue: Maybe<string>
  carrierId?: string
  carrierLinkPosition?: 'top' | 'bottom' | 'none'
  reduced?: boolean
}

const CarrierSummaryCard = memo<ICarrierSummaryCardProps>(
  ({
    bounceRate,
    carrierId,
    carrierName,
    carrierScore,
    dotNumber,
    hqValue,
    mcNumber,
    onTimeRate,
    rate,
    shipmentsCount,
    status,
    trackingRate,
  }) => {
    return (
      <Card>
        <Typography variant='h3'>{carrierName}</Typography>
        <ExtendedCarrierScorecard
          carrierName={carrierName}
          mcNumber={mcNumber}
          dotNumber={dotNumber}
          hqValue={hqValue}
          status={status}
          rate={rate}
          bounceRate={bounceRate}
          onTimeRate={onTimeRate}
          trackingRate={trackingRate}
          carrierScore={carrierScore}
          carrierId={carrierId}
          shipmentsCount={shipmentsCount}
          reduced
        />
      </Card>
    )
  }
)

export default CarrierSummaryCard
